function initialState() {
  return {
    id: null,
    root: true,
    name: '',
    image: '',
    inactive: false,
    peopleCount: 0,
    description: '',
    parentGroupID: null,
    childrenCount: 0,
    children: [],
  }
}

const initial = initialState()

const getters = {
  account: state => state,
}

const actions = {
  changeDescription({ commit }, description) {
    commit('CHANGE_DESCRIPTION', description)
  },
}

const mutations = {
  async LOAD_CURRENT_ACCOUNT(state, account) {
    for (var key in state) {
      state[key] = account[key]
    }
  },
  CHANGE_DESCRIPTION(state, description) {
    state.description = description
  },
}

export default {
  namespaced: true,
  state: initial,
  actions,
  getters,
  mutations,
}
